module.exports = __webpack_public_path__ + "img/21.d253144c.png";